<template>
  <div class="convo-panel-head">
    <div class="convo-panel-avatar" >
      <div class="user-avatar" @click="goToProfile">
        <img
          :src="generateImageUrl(formattedReceiverInfo.imageUrl)"
          alt="profile-pic"
        />
      </div>
      <div class="convo-name">
        <div class="convo-name-title" @click="goToProfile">
          {{ formattedReceiverInfo.name }}
          <span style="font-size: 12px;color: grey"
            >{{ formattedReceiverInfo.city }},
            {{ formattedReceiverInfo.state }}</span
          >
        </div>
        <div class="extra-info">
          <div class="convo-time position" @click="goToMainProfile">
            {{ formattedReceiverInfo.description }}
          </div>
          <div class="convo-time" v-if="receiverInfo.lastOnlineDate && (selectedConversation &&
        selectedConversation.blockBy &&
        selectedConversation.blockBy.length < 1) && (!basicPlayer)">
            Active
            {{
              selectedConversation.status
                ? "Now"
                : $options.filters.convertToFromNowFormat(
                    selectedConversation.lastOnlineDate
                  )
            }}
          </div>
        </div>
      </div>
    </div>
    <div class="convo-actions">
      <div class="back-to-list" @click="goback">
        <a-icon type="left" />
        Back
      </div>
      <div class="main-actions">
        <div class="search-list-input" :class="{ active: searchUser }">
          <div class="chat-box-wrapper">
            <a-icon
              v-if="!searchContainerShow"
              type="search"
              class="search-button"
              @click="searchInput"
            />
            <a-input
              v-else
              ref="search"
              placeholder="Search Message"
              @keydown.enter="event => onSearch(event.target.value)"
              class="search-message"
              :value="searchQuery"
            >
              <a slot="suffix" @click="closeSearch">
                <BaseIcon type="close-circle" />
              </a>
            </a-input>
            <div
              class="message-container"
              v-if="searchContainerShow && searchedMessagesLoading"
            >
              <div class="no-messages">
                {{ loadingText }}
              </div>
            </div>
            <div
              class="message-container"
              v-if="
                searchContainerShow &&
                  searchedMessages.length === 0 &&
                  searchQuery &&
                  !searchedMessagesLoading
              "
            >
              <div class="no-messages">
                No messages match the query
              </div>
            </div>
            <div
              class="message-container"
              v-if="
                searchContainerShow &&
                  searchedMessages.length > 0 &&
                  !searchedMessagesLoading
              "
            >
              <div
                v-for="(message, index) in searchedMessages"
                :key="index"
                @click="handleMessageSearch(message)"
                class="search-message-text"
              >
                <div class="message-image-wrapper">
                  <BaseImageWrapper
                    :name="messageDetails(message.msgFrom).name"
                    wrapper-style="circle"
                    :size="40"
                    :image-url="
                      generateImageUrl(messageDetails(message.msgFrom).imageUrl)
                    "
                  />
                </div>

                <div class="message-body-wrapper">
                  <p>{{ messageDetails(message.msgFrom).name }}</p>
                  <p>
                    {{
                      message.chatMessage.length > 55
                        ? `${message.chatMessage.substr(0, 55)}...`
                        : message.chatMessage
                    }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <BaseModal
          :visible="showIgnoreModal"
          :ok-button-props="{ class: 'danger-button' }"
          title="Ignore this conversation?"
          ok-text="Ignore Messages"
          ok-type="danger"
          @cancel="toggleModal('showIgnoreModal')"
          @ok="ignoreUser"
        >
          <p slot="content">
            You won't be notified when
            <span class="bold">{{
              selectedConversation.receiverId.coachname ||
                selectedConversation.receiverId.athletename
            }}</span>
            messages you directly, and the conversation will move to ignored
            contacts. We won't tell
            <span class="bold">{{
              selectedConversation.receiverId.coachname ||
                selectedConversation.receiverId.athletename
            }}</span>
            that the messages have been ignored.
          </p>
        </BaseModal>
        <BaseModal
          :visible="showBlockModal"
          :ok-button-props="{ class: 'danger-button' }"
          title="Block this user?"
          ok-text="Block User"
          ok-type="danger"
          @cancel="toggleModal('showBlockModal')"
          @ok="blockUser"
        >
          <p slot="content">
            <span class="bold">{{
              selectedConversation.receiverId.coachname ||
                selectedConversation.receiverId.athletename
            }}</span>
            won't be able to send you messages, and the conversation will move
            to blocked contacts. We won't tell
            <span class="bold">{{
              selectedConversation.receiverId.coachname ||
                selectedConversation.receiverId.athletename
            }}</span>
            that the user has been blocked.
          </p>
        </BaseModal>
        <BaseModal
          :visible="showEnableModal"
          title="Enable this user?"
          ok-text="Enable User"
          ok-type="primary"
          @cancel="toggleModal('showEnableModal')"
          @ok="enableUser"
        >
          <p slot="content">
            <span class="bold">{{
              selectedConversation.receiverId.coachname ||
                selectedConversation.receiverId.athletename
            }}</span>
            will be able to send you messages, and the conversation will move to
            active contacts.
          </p>
        </BaseModal>
        <BaseModal
          :visible="showDeleteConversationModal"
          :ok-button-props="{ class: 'danger-button' }"
          title="Delete this conversation?"
          ok-text="Delete Conversation"
          ok-type="danger"
          @cancel="toggleModal('showDeleteConversationModal')"
          @ok="deleteChatHistory"
        >
          <p slot="content">
            Conversation with
            <span class="bold">{{
              selectedConversation.receiverId.coachname ||
                selectedConversation.receiverId.athletename
            }}</span>
            will be deleted and you won't be able to see past messages.
          </p>
        </BaseModal>
        <BaseModal
          :visible="showSaveModal"
          title="Save this contact?"
          ok-text="Save Contact"
          ok-type="primary"
          @cancel="toggleModal('showSaveModal')"
          @ok="saveUser"
        >
          <p slot="content">
            <span class="bold">{{
              selectedConversation.receiverId.coachname ||
                selectedConversation.receiverId.athletename
            }}</span>
            will be moved to saved contacts.
          </p>
        </BaseModal>
        <a-dropdown placement="bottomRight" :trigger="['click']">
          <a-icon type="more" />
          <a-menu slot="overlay">
            <a-menu-item
              v-if="
                !selectedConversation.isContactSaved &&
                  !selectedConversation.contactIsBlocked &&
                  !selectedConversation.contactIsIgnored
              "
            >
              <a @click="toggleModal('showSaveModal')">Save User</a>
            </a-menu-item>
            <a-menu-item v-if="selectedConversation.contactIsBlocked">
              <a @click="toggleModal('showEnableModal')">Enable User</a>
            </a-menu-item>
            <a-menu-item
              v-if="
                !selectedConversation.contactIsBlocked &&
                  !selectedConversation.contactIsIgnored &&
                  !selectedConversation.isContactSaved
              "
            >
              <a @click="toggleModal('showIgnoreModal')">Ignore User</a>
            </a-menu-item>
            <a-menu-item v-if="!selectedConversation.contactIsBlocked">
              <a @click="toggleModal('showBlockModal')">Block User</a>
            </a-menu-item>
            <a-menu-item>
              <a @click="toggleModal('showDeleteConversationModal')"
                >Delete Conversation</a
              >
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import { Chat } from "@/models";
import { mapGetters } from "vuex";

const STORE_KEY = "chatStore";

export default {
  name: "ConvoHead",
  data() {
    return {
      searchUser: false,
      searchContainerShow: false,
      searchQuery: "",
      loadingText: "Loading",
      showIgnoreModal: false,
      showBlockModal: false,
      showEnableModal: false,
      showDeleteConversationModal: false,
      showSaveModal: false
    };
  },
  props: {
    selectedConversation: {
      type: Object,
      default: null
    },
    basicPlayer: {
      type: Boolean,
      default: false
    },
    receiverIsClubCoach: {
      type: Boolean,
      default: false
    },
  },
  mounted() {
    setInterval(this.startLoadingTextChange, 300);
  },
  computed: {
    ...mapGetters({
      searchedMessages: `${STORE_KEY}/searchedMessages`,
      currentPage: `${STORE_KEY}/currentPage`,
      searchedMessagesLoading: `${STORE_KEY}/searchedMessagesLoading`,
      receiverInfo: `${STORE_KEY}/receiverProfile`
    }),
    formattedReceiverInfo() {
      return Chat.formatReceiverInfo(this.receiverInfo);
    }
  },
  methods: {

    goToMainProfile(){
      const {uniqueSlug} = this.receiverInfo;
      if(uniqueSlug === "collegeCoach" ){
        const newWindow = window.open(
          `${window.location.origin}/${this.$route.params.profileId}/college_profile/${this.receiverInfo.CollegeId.id}/summary`
        )
      }else if( uniqueSlug === "clubCoach" ){
                const newWindow = window.open(
          `${window.location.origin}/${this.$route.params.profileId}/club_profile/${this.receiverInfo.clubId.id}/summary`
        )
      }else{
                const newWindow = window.open(
          `${window.location.origin}/${this.$route.params.profileId}/athlete/${this.receiverInfo._id}/summary`
        );
      }
    },
    goToProfile() {
      if (this.receiverInfo.uniqueSlug === "athlete") {
        const newWindow = window.open(
          `${window.location.origin}/${this.$route.params.profileId}/athlete/${this.receiverInfo._id}/summary`
        );
        newWindow.focus();
      } else if (this.receiverInfo.uniqueSlug === "clubCoach") {
        const newWindow = window.open(
          `${window.location.origin}/${this.$route.params.profileId}/club/coaching_staffs/${this.receiverInfo._id}/details`
        );
        newWindow.focus();
      } else {
        const newWindow = window.open(
          `${window.location.origin}/${this.$route.params.profileId}/college_profile/coaching_staffs/${this.receiverInfo._id}/details`
        );
        newWindow.focus();
      }
    },
    goback() {
      this.$emit("go-back");
    },
    startLoadingTextChange() {
      this.loadingText = `${this.loadingText}.`;
      if (this.loadingText.includes("....")) this.loadingText = "Loading";
    },
    searchInput() {
      this.searchUser = !this.searchUser;
      this.searchContainerShow = !this.searchContainerShow;
    },
    onSearch(val) {
      this.searchQuery = val;
      this.$emit("type-on-search", this.searchQuery);
      if (!val) return;
      this.$store.dispatch(`${STORE_KEY}/searchMessages`, {
        q: val,
        searchField: "chatMessage",
        sort: "createdAt",
        userId: Chat.profileId(),
        room: [
          this.selectedConversation.senderId,
          this.selectedConversation.receiverId.Id
        ]
          .sort()
          .join("")
      });
    },
    closeSearch() {
      this.searchUser = false;
      this.searchQuery = "";
      this.$store.dispatch(`${STORE_KEY}/clearSearchedMessages`);
      this.$emit("type-on-search", this.searchQuery);
      this.searchContainerShow = !this.searchContainerShow;
    },
    async blockUser() {
      await this.$store.dispatch(`${STORE_KEY}/blockUser`, {
        senderId: Chat.profileId(),
        receiverId: this.receiverInfo._id,
        receiverName:
          this.receiverInfo.coachname || this.receiverInfo.athletename
      });
      this.$store.dispatch(
        `${STORE_KEY}/deleteContactLocally`,
        this.selectedConversation
      );
      this.$emit("clear-conversation");
      this.$emit("go-back");
    },
    async ignoreUser() {
      await this.$store.dispatch(`${STORE_KEY}/ignoreUser`, {
        senderId: Chat.profileId(),
        receiverId: this.receiverInfo._id,
        receiverName:
          this.receiverInfo.coachname || this.receiverInfo.athletename,
        isIgnore: true,
        message: `${this.receiverInfo.coachname ||
          this.receiverInfo.athletename} has been ignored.`
      });
      this.$store.dispatch(
        `${STORE_KEY}/deleteContactLocally`,
        this.selectedConversation
      );
      this.$emit("clear-conversation");
      this.$emit("go-back");
    },
    async enableUser() {
      await this.$store.dispatch(`${STORE_KEY}/unblockUser`, {
        senderId: Chat.profileId(),
        receiverId: this.receiverInfo._id,
        receiverName:
          this.receiverInfo.coachname || this.receiverInfo.athletename
      });
      this.$store.dispatch(
        `${STORE_KEY}/setBlockedToFalse`,
        this.selectedConversation
      );
      await this.$store.dispatch(`${STORE_KEY}/ignoreUser`, {
        senderId: Chat.profileId(),
        receiverId: this.receiverInfo._id,
        receiverName:
          this.receiverInfo.coachname || this.receiverInfo.athletename,
        isIgnore: false
      });
      this.$store.dispatch(
        `${STORE_KEY}/deleteContactLocally`,
        this.selectedConversation
      );
      this.$emit("clear-conversation");
      this.$emit("go-back");
    },
    async saveUser() {
      this.$store.dispatch(`${STORE_KEY}/saveUser`, {
        senderId: Chat.profileId(),
        receiverId: this.receiverInfo._id,
        receiverName:
          this.receiverInfo.coachname || this.receiverInfo.athletename,
        isContactSaved: true
      });
      this.$store.dispatch(
        `${STORE_KEY}/deleteContactLocally`,
        this.selectedConversation
      );
      this.$emit("clear-conversation");
      this.$emit("go-back");
    },
    async restoreUser() {
      await this.$store.dispatch(`${STORE_KEY}/saveUser`, {
        senderId: Chat.profileId(),
        receiverId: this.receiverInfo._id,
        receiverName:
          this.receiverInfo.coachname || this.receiverInfo.athletename,
        isContactSaved: false
      });
      this.$store.dispatch(
        `${STORE_KEY}/deleteContactLocally`,
        this.selectedConversation
      );
      this.$emit("clear-conversation");
      this.$emit("go-back");
    },
    async handleMessageSearch(message) {
      await this.$store.dispatch(`${STORE_KEY}/getMessagePage`, {
        id: message.id,
        room: [message.msgFrom, message.msgTo].sort().join(""),
        userId: Chat.profileId()
      });
      this.$store.dispatch(`${STORE_KEY}/setPageHistory`, [this.currentPage]);
      this.$emit("message-search", message);
    },
    async deleteChatHistory() {
      await this.$store.dispatch(`${STORE_KEY}/deleteMessages`, {
        userContactId: this.selectedConversation.id,
        room: [
          this.selectedConversation.senderId,
          this.selectedConversation.receiverId.Id
        ]
          .sort()
          .join(""),
        senderId: this.selectedConversation.senderId
      });
      this.$store.dispatch(`${STORE_KEY}/emptyMessages`);
      this.$store.dispatch(
        `${STORE_KEY}/deleteContactLocally`,
        this.selectedConversation
      );
      this.$emit("clear-conversation");
      this.showDeleteConversationModal = false;
      this.$emit("go-back");
    },
    messageDetails(messageFrom) {
      const details =
        messageFrom === Chat.profileId()
          ? {
              name: Chat.userName(),
              imageUrl: Chat.userImage()
            }
          : {
              name:
                this.receiverInfo.athletename || this.receiverInfo.coachname,
              imageUrl:
                this.receiverInfo.profileImage || this.receiverInfo.image
            };
      return details;
    },
    clearSearchQuery() {
      this.searchQuery = "";
      this.$emit("type-on-search", this.searchQuery);
    },
    toggleModal(modalName) {
      this[modalName] = !this[modalName];
    }
  }
};
</script>

<style lang="scss">
.bold {
  font-weight: 500;
  color: #000;
}
.danger-button {
  background-color: #d73228 !important;
  border-color: #d73228 !important;
}
.convo-panel-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #dadce0;
  padding: 15px 20px;
  .convo-panel-avatar {
    display: flex;
    align-items: center;
    cursor: pointer;
    .user-avatar {
      width: 55px;
      height: 55px;
      margin-right: 1em;
    }
    .convo-name {
      .convo-name-title {
        font-size: 16px;
        font-weight: 500;
        color: #3e4247;
        margin-bottom: 3px;
      }
      .extra-info {
        .convo-time {
          font-weight: 400;
          font-size: 12px;
          color: #acb6d1;
          &.position {
            color: grey;
            font-weight: 500;
            padding-right: 5px;
          }
        }
      }
    }
  }
  .convo-actions {
    display: flex;
    align-items: center;
    .back-to-list {
      display: none;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      color: grey;
      font-weight: 500;
      .anticon {
        padding-left: 0;
        padding-right: 3px;
        font-size: 14px;
        position: relative;
        top: -1px;
        color: #000;
      }
    }
    .main-actions {
      display: flex;
      align-items: center;
    }
    .search-list-input {
      .chat-box-wrapper {
        display: flex;
        flex-direction: column;
        z-index: 999;
        width: 35px;
        position: relative;
        .message-container {
          background: white;
          right: -5px;
          top: 3.9rem;
          border-radius: 4px;
          width: 16rem;
          position: absolute;
          border: 1px solid lightgray;
          height: 200px;
          overflow-y: auto;
          font-size: 11px;
          .no-messages {
            padding: 1rem;
            font-weight: 500;
            text-align: center;
          }
          .search-message-text {
            display: grid;
            grid-template-columns: 3fr 9fr;
            border-bottom: 1px solid lightgray;
            padding: 8px 12px;
            p {
              margin: 0 !important;
            }
            .message-body-wrapper {
              margin-left: 1rem;
            }
            .message-body-wrapper :first-child {
              font-weight: 500 !important;
            }
            .message-image-wrapper {
              align-self: center;
            }
          }
        }
        .message-container :hover {
          cursor: pointer;
          background: lightblue;
        }
        .message-container :last-child {
          border-bottom: none !important;
        }
      }
      .search-message {
        opacity: 0;
        left: 0;
        transform: translateX(20px);
        width: 225px;
        z-index: -1;
        transition: all 0.5s ease-in-out;
        input {
          border: 1px solid #eaeaea !important;
          padding-right: 45px;
          padding-left: 20px;
        }
        .anticon {
          &:hover {
            background: #ffffff;
            color: #949aa2;
          }
        }
      }
      &.active {
        .search-message {
          opacity: 1;
          z-index: 0;
          transform: translateX(-185px);
        }
      }
    }
    .anticon {
      color: #949aa2;
      margin-right: 8px;
      font-size: 18px;
      transition: all 0.2s linear;
      padding: 8px;
      border-radius: 50%;
      overflow: hidden;
      cursor: pointer;
      &:last-child {
        margin-right: 0;
      }
      &:hover {
        background: red;
        color: #ffffff;
      }
    }
  }
}

@media only screen and (max-width: 575px) {
  .convo-panel-head {
    align-items: flex-start;
    flex-direction: column;
    padding-right: 5px;
    padding-bottom: 5px;
    .convo-panel-avatar {
      align-items: flex-start;
      width: 100%;
      .user-avatar {
        display: none;
      }
      .convo-name {
        .convo-name-title {
          span {
            margin-left: 5px;
          }
        }
      }
    }
    .convo-actions {
      justify-content: space-between;
      width: 100%;
      padding-top: 5px;
      .back-to-list {
        display: flex;
      }
      .search-list-input {
        .chat-box-wrapper {
          padding: 0;
        }
      }
    }
  }
}
</style>
